export default __webpack_public_path__ + "static/media/m_wdt_c_7.6f15f2f0.mp3";